export default "__VITE_ASSET__B8rWmfiB__"